<div
  class="px-base py-[10px] flex items-center justify-between border-b border-ui-separator bg-gray-50"
  [ngClass]="{ 'bg-primary/15': isAdvancedMode }"
>
  <div class="text-base leading-base font-semibold">Filters</div>

  <lla-checkbox-element
    class="block mt-xs md:ml-sm self-end md:self-start"
    label="Advanced"
    [value]="!!isAdvancedMode"
    (click)="setAdvancedMode()"
  ></lla-checkbox-element>
</div>
